export default "__VITE_ASSET__BnAiRpy6__"